var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{attrs:{"xs6":"","md4":"","sm3":"","lg4":"","xl4":"","pt0":""}},[_c('span',{staticClass:"font-weight-bold pr-2"},[_vm._v(_vm._s(_vm.$t(_vm.label))+" ")]),_vm._v("\n  "+_vm._s(_vm.value)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }